import React, { Component } from 'react'
import { connect } from 'react-redux'

class BkFlowEditGuestFieldDogs extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const { configData, enableDogs, toggleDogs } = this.props

		const hotelLabels = configData.hotel.labels[0]

		return (
			<div className="bk-flow-edit-guest__field-col half">
				<p className="bk-flow-edit-guest__field-heading u-font-xs u-remove-margin">{ hotelLabels.dog }</p>
				<button
					className={ enableDogs ? 'bk-flow-edit-guest__field-check decrement active row' : 'bk-flow-edit-guest__field-check decrement row' }
					onClick={ () => toggleDogs() }
				>
					<div className="bk-flow-edit-guest__field-check-box col-xs"></div>
					<div className="bk-flow-edit-guest__field-check-icon dogs col-xs"></div>
				</button>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration
})

export default connect(mapStateToProps, null)(BkFlowEditGuestFieldDogs)


// WEBPACK FOOTER //
// ./src/components/edit/guest/elements/BkFlowEditGuestFieldDogs.js